import { render, staticRenderFns } from "./StaffBundle.vue?vue&type=template&id=935585c6&scoped=true&"
import script from "./StaffBundle.vue?vue&type=script&lang=js&"
export * from "./StaffBundle.vue?vue&type=script&lang=js&"
import style0 from "./StaffBundle.vue?vue&type=style&index=0&id=935585c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935585c6",
  null
  
)

export default component.exports